import React from 'react';
import { connect } from 'react-redux';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './CandidateShowWrapper.scss';
import CandidateInfoDataTable, {
  candidatePersonalTableMapping,
  candidatePoliticalMapping,
} from './CandidateInfoDataTable';
import ReadMoreLess from '../ReadMoreLess/ReadMoreLess';
import CandidateStatus from './CandidateStatus';
import { loadLatestYearTopCandidateData } from '../../../routes/newslisting/redux';
import ConstituencyWidget from '../ConstituencyWidget/ConstituencyWidget';
import ConstituencyCandidate from '../ConstituencyCandidate/ConstituencyCandidate';
import AdrData from './AdrData';
// import Link from '../../../components/Link/Link';
// import Listingheader from '../../../routes/home/components/common/ListingheaderV2';

class CandidateShowWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    const data = this.props?.sectionItem;
    const { electionData } = data?.dataMapping;
    try {
      if (electionData) {
        const liveData = Object.values(electionData).filter(
          d => d.live === true,
        );
        if (liveData && Array.isArray(liveData) && liveData.length) {
          const [{ source }] = liveData || [{ source: '' }];
          this.state.source = source;
        }
      }
    } catch (error) {
      //
    }
  }

  componentDidMount() {
    const data = this.props.sectionItem;
    const { electionData } = data.dataMapping;
    if (electionData) {
      const liveData = Object.values(electionData).filter(d => d.live === true);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const [{ url }] = liveData || [{ url: '' }];
        if (url) {
          setInterval(() => {
            this.props.loadAjaxLatestYearData(
              url,
              data.candidateInfo.cns_name,
              5,
            );
          }, 30 * 1000);
        }
      }
    }
  }

  render() {
    const { latestYearData, sectionItem, loksabha, isWapView } = this.props;
    const { electionData } = sectionItem.dataMapping;
    const { cnsID, candidateInfo } = sectionItem;
    return (
      <div className={s.candidateShowWrapper}>
        <div className={s.bio}>
          <div className={s.bioImage}>
            <div className={s.content}>
              <ImageV2
                resizemode="75"
                width="360"
                msid={candidateInfo.img ? candidateInfo.img : '69347424'}
                // msid="69347424"
                alt={candidateInfo.cn}
              />
            </div>
            {isWapView && <div className={s.name}>{candidateInfo?.cn}</div>}
          </div>
          <div className={s.bioDetails}>
            {!isWapView && <div className={s.name}>{candidateInfo?.cn}</div>}
            <div className={s.resultStatus}>
              <CandidateStatus candidateList={[candidateInfo]} />
            </div>
          </div>
          <div className={s.readMoreWrap}>
            <ReadMoreLess
              information={candidateInfo?.bio}
              readMoreLengthLimit={this.props.isWapView ? 50000 : 50000}
            />
          </div>
        </div>
        <div className={`${s.boxWrap}`}>
          <CandidateInfoDataTable
            title="Political Information"
            tableMapping={candidatePoliticalMapping}
            data={candidateInfo}
          />
        </div>
        <div className={`${s.boxWrap}`}>
          <CandidateInfoDataTable
            title="Personal Information"
            tableMapping={candidatePersonalTableMapping}
            data={candidateInfo}
          />
        </div>
        <div className={`${s.boxWrap}`}>
          <AdrData />
        </div>
        {electionData[latestYearData?.year] &&
          electionData[latestYearData?.year]?.note &&
          electionData[latestYearData?.year]?.noteCnsIds &&
          electionData[latestYearData?.year]?.noteCnsIds.includes(cnsID) && (
            <p className={s.noteText}>
              {electionData[latestYearData?.year]?.note}
            </p>
          )}
        {latestYearData?.top_candidates &&
          Array.isArray(latestYearData?.top_candidates) &&
          latestYearData?.top_candidates.length && (
            <ConstituencyWidget
              showStatus
              title={`${latestYearData.year} ${
                loksabha
                  ? `${latestYearData?.name || ''} Lok Sabha`
                  : `${latestYearData?.name || ''} Assembly`
              } Election Results`}
              toBeDecided={
                latestYearData.top_candidates[0].cs === 2 ||
                latestYearData.top_candidates[0].cs === 1 ||
                latestYearData.top_candidates[0].cs === 0
              }
            >
              {latestYearData.top_candidates &&
                Array.isArray(latestYearData.top_candidates) &&
                latestYearData.top_candidates.length &&
                latestYearData.top_candidates.map((candidate, index1) => (
                  <ConstituencyCandidate
                    candidate={candidate}
                    index={index1}
                    isWapView={this.props.isWapView}
                    vm={latestYearData?.vm}
                    candidateLinking={
                      electionData[latestYearData?.year]?.candidateLinking
                    }
                  />
                ))}
            </ConstituencyWidget>
          )}
        {this.state?.source && (
          <div className={`${s.source} ${s.cl}`}>
            Source: {this.state?.source}
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxLatestYearData: (url, constituency, number) => {
    dispatch(loadLatestYearTopCandidateData(url, constituency, number));
  },
});

const mapStateToProps = state => ({
  latestYearData: state.newslisting && state.newslisting?.latestYearData,
  loksabha: state.newslisting && state.newslisting?.loksabha,
});

export default connect(mapStateToProps, mapDispatchtoProps)(
  CandidateShowWrapper,
);
